import React, { memo } from 'react';
import styled from 'styled-components';
import { LargeHourlyForecastView } from './desktopTabletViews/largeHourlyForecastView';
import { ForecastSubTabLocationTitle } from '../common/forecastSubTabLocationTitle';
import { PageContentContainerStyle, ForecastDataContainer } from '../styles';
import { MobileHourlyForecastView } from '../hourlyForecast/mobileView/mobileHourlyForecastView';
import { hourlyForecastScrollableViewId } from '../common/utils';
import { LeftControllButtonsWrapper } from '../common/leftControllButtonsWrapper';
import { HourlyForecastChart } from './charts/hourlyForecastChart';
import { withScreenSize } from '../../common/utilities/withScreenSize.jsx';

interface HourlyForecastUIViewProps {
    isMobile: boolean;
    isMouseBtnDown: boolean;
    scrollForecastCardsEvent(): void;
    handleMouseLeaveOrUp(): void;
    handleMouseMove(): void;
    handleMouseDown(): void;
}

export const HourlyForecastUIView = memo(withScreenSize(({ 
    scrollForecastCardsEvent,
    isMobile,
    isMouseBtnDown,
    handleMouseLeaveOrUp,
    handleMouseMove,
    handleMouseDown
}: HourlyForecastUIViewProps) => {

    return (
        <HourlyWrapper>
            <SectionWrappers key='sub-tab-location-title'>
                <ForecastSubTabLocationTitle isMobile={isMobile} />
            </SectionWrappers>
            <ForecastDataContainer 
                isMouseBtnDown={isMouseBtnDown}
                onScroll={scrollForecastCardsEvent}
                onMouseUp={handleMouseLeaveOrUp}
                onMouseLeave={handleMouseLeaveOrUp}
                onMouseMove={handleMouseMove}
                onMouseDown={handleMouseDown} 
                id={hourlyForecastScrollableViewId}>
                <LeftControllButtonsWrapper />
                <SectionWrappers key='cards-ui-view-and-controls-wrapper'>
                    <LargeHourlyForecastView />
                </SectionWrappers>
                {!isMobile && <HourlyForecastChart />}
                <MobileHourlyForecastView />
            </ForecastDataContainer>
        </HourlyWrapper>
    );
}));

HourlyForecastUIView.displayName = 'HoulyForecastWrapper';

const HourlyWrapper = styled.div`
    margin-top: -10px;
`;

const SectionWrappers = styled.div`
    ${PageContentContainerStyle}
`;